export default "__VITE_ASSET__cdb5c37e__"